<template>
	<div>
		<b-row class="mb-1">
			<b-col class="d-flex align-items-center">
				<small class="text-secondary">
					Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
				</small>
			</b-col>
			<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
				<b-pagination
					v-model="pagination.curPage"
					:total-rows="pagination.total"
					:per-page="pagination.perPage"
					first-number
					last-number
					class="mb-0 mt-1 mt-sm-0"
					prev-class="prev-item"
					next-class="next-item"
				>
					<template #prev-text>
						<feather-icon icon="ChevronLeftIcon" size="18" />
					</template>
					<template #next-text>
						<feather-icon icon="ChevronRightIcon" size="18" />
					</template>
				</b-pagination>
			</b-col>
		</b-row>
		<b-row class="mb-1">
			<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mb-md-0">
				<label>Mostrar</label>
				<v-select
					v-model="pagination.perPage"
					:options="perPageOptions"
					:clearable="false"
					class="per-page-selector d-inline-block mx-50"
					style="width: 90px"
				/>
				<label class="mr-2">registros</label>
				<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
			</b-col>
			<b-col cols="12" xl="5"></b-col>
		</b-row>
		<b-table-simple responsive sticky-header="60vh" no-border-collapse>
			<b-thead class="sticky-header" style="white-space: nowrap">
				<b-th class="text-center">Incidencia</b-th>
				<!-- <b-th class="text-center">Estado Previo</b-th> -->
				<b-th class="text-center">Estado</b-th>
				<b-th class="text-center">Creado por</b-th>
				<!-- <b-th class="text-center">Estado Final</b-th> -->
				<!-- <b-th class="text-center">Finalizado por</b-th> -->
			</b-thead>
			<b-tbody>
				<template v-if="rows.length > 0">
					<b-tr v-for="(row, index) in rows" :key="index">
						<b-td class="text-center">
							<span>
								{{ row.incidence_name }}
							</span>
						</b-td>
						<!-- <b-td class="text-center">
							<span>{{ getTrainingStatusName(row.training_status_id) }}</span>
						</b-td> -->
						<b-td class="text-center">
							<span>
								{{ row.new_status_id ? "FINALIZADO" : "PENDIENTE" }}
							</span>
						</b-td>
						<b-td class="text-center">
							<div>{{ row.creator_name }}</div>
							<div>{{ row.created_at | myGlobalDayWithHour }}</div>
						</b-td>
						<!-- <b-td class="text-center">
							<span>{{ getTrainingStatusName(row.new_status_id) }}</span>
						</b-td> -->
						<!-- <b-td class="text-center">
							<div>{{ row.updated_by_name }}</div>
							<div>{{ row.updated_at | myGlobalDayWithHour }}</div>
						</b-td> -->
					</b-tr>
				</template>
				<b-tr v-if="rows.length === 0">
					<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</div>
</template>

<script>
import PreparacionService from "@/services/preparacion/default.service.js"
export default {
	components: {},
	props: {
		info: Object,
	},
	data() {
		return {
			isLoading: false,
			rows: [],
			perPageOptions: [10, 25, 50],
			pagination: {
				total: 0,
				curPage: 1,
				perPage: 25,
				from: 0,
				to: 0,
			},
		}
	},
	async created() {
		await this.getDetails()
	},
	computed: {},
	methods: {
		handleInputSearch() {
			this.getDetails()
		},
		refresh() {
			this.getDetails()
		},
		getTrainingStatusName(statusId) {
			if (!statusId) return "SIN ESTADO"
			if (statusId == 1) return "EN  PROCESO"
			if (statusId == 2) return "PRE-LISTOS"
			if (statusId == 3) return "CANCELADO"
			if (statusId == 6) return "TRIP"
		},
		async refresh() {
			await this.getDetails()
		},
		handleHidden() {
			this.isLoading = false
			this.$emit("closing")
		},
		async getDetails(page = 1) {
			this.isPreloading()
			try {
				const { data } = await PreparacionService.getPreparationIncidencesBySpecimenId({
					specimen_id: this.info.id,
					page: page,
					per_page: this.pagination.perPage,
				})
				this.rows = data.data
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getDetails(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getDetails()
		},
	},
}
</script>

<style></style>
